import { cn } from '@hrms/ui';

/** "n of 6 done" as a thin bar. Counts steps, not percent, so a screen reader says the same thing. */
export function SetupProgressBar({
  done,
  total,
  className,
}: {
  done: number;
  total: number;
  className?: string;
}) {
  const width = total > 0 ? Math.round((done / total) * 100) : 0;
  return (
    <div
      role="progressbar"
      aria-label="Setup progress"
      aria-valuemin={0}
      aria-valuemax={total}
      aria-valuenow={done}
      aria-valuetext={`${done} of ${total} steps done`}
      className={cn('h-1.5 w-full overflow-hidden rounded-full bg-bg-subtle', className)}
    >
      <div
        className="h-full rounded-full bg-accent transition-[width] duration-[var(--duration-fast)]"
        style={{ width: `${width}%` }}
      />
    </div>
  );
}
